import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select, TextField } from "ui";
import { MenuItem } from "@mui/material";
import VippsModel from "./types/VippsModel";
import FormRef from "../types/FormRef";
import scopes from "./scopes";

type VippsFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: VippsModel) => void;
};

const VippsForm = forwardRef<FormRef, VippsFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                    merchant_id: {},
                    scopes: { default: ["email", "name", "phoneNumber"] },
                    transaction_text: {},
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Merchant ID">
                                    <TextField
                                        fullWidth
                                        id="merchant_id"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Scopes">
                                    <Select id="scopes" fullWidth multiple>
                                        {scopes.map(
                                            (item: string, idx: number) => {
                                                return (
                                                    <MenuItem
                                                        value={item}
                                                        key={`${item}-${idx}`}
                                                    >
                                                        {item}
                                                    </MenuItem>
                                                );
                                            },
                                        )}
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Transaction Text">
                                    <TextField
                                        fullWidth
                                        id="transaction_text"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default VippsForm;
